import { Outlet, RouteObject } from 'react-router-dom';
import UtilsDashboard from 'pages/utils-dashboard/UtilsDashboard';
import React, { Suspense } from 'react';
import ProtectedRoute from 'protected-route';
import Login from 'pages/login/Login';
import { Spinner } from 'components/common';
import NotFoundPage from 'pages/errors/NotFoundPage';

export const createAppRoutes = (LayoutWrapper: React.ReactElement): RouteObject[] => [
  {
    path: '/',
    element: LayoutWrapper, // This element wraps all routes
    children: [
      {
        path: 'login',
        element: (
          <Suspense fallback={<Spinner />}>
            <Login />
          </Suspense>
        ),
      },
      {
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Spinner />}>
                <UtilsDashboard />
              </Suspense>
            ),
          },
          {
            path: '*',
            element: (
              <Suspense fallback={<Spinner />}>
                <NotFoundPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];
